import { useAppDispatch, useAppSelector } from "./hooks";
import { AuthContext, IAuthContext } from "react-oauth2-code-pkce";
import { JSX, useContext, useLayoutEffect } from "react";
import { setAuthToken } from "./rootReducer";
import App from "./App";
import AppLoader from "../common/components/AppLoader";
import AbsLogo from "../common/images/AbsLogo.svg";

const AuthWrapper = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const authToken = useAppSelector((state) => state.root.authToken);
    const { token, loginInProgress } = useContext<IAuthContext>(AuthContext);

    useLayoutEffect(() => {
        dispatch(setAuthToken(token));
    }, [dispatch, token]);

    if (!token || loginInProgress || authToken !== token) {
        return <AppLoader logoSrc={AbsLogo} />;
    }

    return <App />;
};

export default AuthWrapper;
